import { useEffect } from "react";
import { useDemo } from "../zustand/DemoZustand";
import Fraktionschat from "./Fraktionschat";

/*
  Ein Kanal, ganz geöffnet.

  Hier steht der vollständige Verlauf eines Gremiums — über alle Sitzungen
  hinweg. Genau darin liegt der Gewinn des Zuschnitts: Der Bebauungsplan
  Nr. 47 kommt als Auslegungsbeschluss, als Abwägung und als Satzungsbeschluss
  wieder, und die Vorgeschichte steht jedes Mal darüber.

  Beim Öffnen gilt alles Bisherige als gesehen. Das passiert absichtlich hier
  und nicht in der Liste: Wer eine Übersicht ansieht, hat noch nichts gelesen.
*/

export default function KanalAnsicht({ kanalId, zitat, oeffne }) {
  const { stammdaten, aktionen } = useDemo();
  const kanal = (stammdaten.kanaele || []).find((k) => k.id === kanalId);

  useEffect(() => {
    if (kanalId) aktionen.markiereKanalGelesen(kanalId);
  }, [kanalId, aktionen]);

  if (!kanal) {
    return (
      <div className="karte" style={{ marginTop: "1.5rem" }}>
        <p>Dieser Kanal wurde nicht gefunden.</p>
        <button
          className="knopf knopf--zurueckhaltend"
          style={{ marginTop: "var(--luft-4)" }}
          onClick={() => oeffne("chats", {})}
        >
          Zu den Kanälen
        </button>
      </div>
    );
  }

  return (
    <>
      <div className="detailkopf">
        <p className="detailkopf__vorspann">Kanal · {kanal.art}</p>
        <h1 className="detailkopf__titel">{kanal.name}</h1>
        <p className="klein leise" style={{ marginTop: "var(--luft-2)" }}>
          Alle 13 Mitglieder der Fraktion lesen mit. Der Verlauf läuft über die einzelne Sitzung
          hinaus.
        </p>
      </div>

      {/*
        Der Verweis an einer Blase führt zum Tagesordnungspunkt — und zwar in
        dessen Chat-Reiter, also genau dorthin, wo dieselbe Unterhaltung
        gefiltert steht. Wer von dort weiterliest, ist nicht umgestiegen,
        sondern hat nur den Ausschnitt gewechselt.
      */}
      <Fraktionschat
        kanalId={kanal.id}
        /* Eine Notiz, die jemand in den Chat gegeben hat, steht schon im Feld. */
        annotationId={zitat}
        /*
          Ein Verweis führt dorthin, worum es ging — zum Tagesordnungspunkt
          oder zur Aufgabe. Ein Verweis, dem man nicht folgen kann, ist
          keiner.
        */
        aufBezug={(ziel) => {
          if (ziel.art === "aufgabe") oeffne("aufgaben", { aufgabeId: ziel.id });
          else oeffne("sitzung", { topId: ziel.top.id, reiter: "chat" });
        }}
        eingebettet
      />
    </>
  );
}
